import { Button } from "antd";
import { useHistory } from "react-router";

import { INDEX_ROUTE } from "routes";

const NotFoundPage = () => {
  const history = useHistory();
  return (
    <div className="not-found-page">
      <div className="text-center">
        <p className="text-large font-bold secondary-font secondary">
          Page not found
        </p>
        <Button
          size="large"
          type="primary"
          className="mt-12"
          onClick={() => history.push(INDEX_ROUTE)}
        >
          Go back
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
